/**
 * Error helpers for API responses.
 *
 * Parsing lives in extractApiError (lib/api.js), which understands both the
 * backend's standardized envelope { error: { code, message, details } } and
 * FastAPI's raw { detail } shape. These are thin conveniences over it.
 */
import { extractApiError } from "./api";

export function getErrorMessage(error, defaultMessage = "An error occurred") {
  return extractApiError(error, defaultMessage).message;
}

/**
 * Get error code from API response
 */
export function getErrorCode(error) {
  return error?.response?.data?.error?.code || null;
}

export { extractApiError };
